import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { SubProduct } from './types.tsx';

const tagMauEvent = (subProduct: SubProduct): void => {
	performGetRequest(`/rest/internal/2/mauTag/${subProduct}`).catch((err) => {
		log.safeErrorWithoutCustomerData(
			'common.tag-mau.tag-mau-event',
			'Error connecting to monolith mau tag endpoint',
			err,
		);
	});
};

export default tagMauEvent;
